import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "text-grey-brand text-subtitle1 text-bold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 8 }
const _hoisted_12 = { key: 9 }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "col q-pb-sm" }
const _hoisted_15 = {
  key: 0,
  class: "column"
}
const _hoisted_16 = { class: "col q-pb-sm" }
const _hoisted_17 = { class: "col q-pb-sm" }
const _hoisted_18 = {
  key: 1,
  class: "column"
}
const _hoisted_19 = {
  key: 0,
  class: "row justify-center q-pa-md"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_PipelineSectionMarkerPassagesDialog = _resolveComponent("PipelineSectionMarkerPassagesDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.marker.name)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          square: "",
          flat: "",
          bordered: "",
          class: "my-card bg-grey-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, " Marker Name: " + _toDisplayString(_ctx.marker ? _ctx.marker.name : ''), 1)
                  ])
                ]),
                _createElementVNode("p", null, " Marker Description: " + _toDisplayString(_ctx.marker && _ctx.marker.description ? _ctx.marker.description : 'AGM'), 1),
                _createElementVNode("p", null, " State: " + _toDisplayString(_ctx.marker
              ? _ctx.marker.trackState === 'T'
                ? 'Track'
                : _ctx.marker.trackState === 'S'
                ? 'Skip'
                : _ctx.marker.trackState
              : ''), 1),
                (_ctx.linkedUid && !_ctx.isCompletedRun)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Linked UID: " + _toDisplayString(_ctx.linkedUid), 1))
                  : _createCommentVNode("", true),
                (!_ctx.isCompletedRun)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "ETA to marker: " + _toDisplayString(_ctx.etaFormated), 1))
                  : _createCommentVNode("", true),
                (_ctx.marker.note)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Note: " + _toDisplayString(_ctx.marker.note), 1))
                  : _createCommentVNode("", true),
                (
            !_ctx.isCompletedRun &&
            _ctx.marker.trackState === 'T' &&
            !_ctx.linkedUid &&
            (_ctx.getuser() === 'admin' || _ctx.getuser() === 'superadmin')
          )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        "no-caps": "",
                        class: "q-mb-sm btn-brand",
                        disabled: !_ctx.isOnline,
                        onClick: _ctx.onAssignUid
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("Assign UID", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (
            !_ctx.isCompletedRun &&
            _ctx.marker.trackState === 'T' &&
            _ctx.linkedUid &&
            (_ctx.getuser() === 'admin' || _ctx.getuser() === 'superadmin')
          )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        "no-caps": "",
                        class: "q-mb-sm btn-brand",
                        disabled: !_ctx.isOnline,
                        onClick: _ctx.onUnlinkUid
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Unlink UID", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (
            (_ctx.marker.trackState === 'T' || _ctx.isEndpointMarker) &&
            (_ctx.getuser() === 'admin' || _ctx.getuser() === 'superadmin')
          )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        "no-caps": "",
                        class: "q-mb-sm btn-brand",
                        disabled: !_ctx.isOnline,
                        onClick: _ctx.onAddPassage
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Add Manual Passage", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.marker.trackState === 'T' || _ctx.isEndpointMarker)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        "no-caps": "",
                        class: "q-mb-sm btn-brand",
                        disabled: !_ctx.isOnline,
                        onClick: _ctx.onViewPassages
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("View Passages", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (
            !_ctx.isCompletedRun &&
            (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
          )
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 7,
                      dense: "",
                      "no-caps": "",
                      class: "q-mb-sm btn-brand",
                      disabled: !_ctx.isOnline,
                      onClick: _ctx.onChangeState
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.marker.trackState === 'S' ? 'Change to TRACK' : 'Change to SKIP'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.isCompletedRun)
                  ? (_openBlock(), _createElementBlock("br", _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                  (
              !_ctx.isCompletedRun &&
              (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin') &&
              !_ctx.isEndpointMarker
            )
                    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                        key: 0,
                        dense: "",
                        "no-caps": "",
                        class: "q-mb-sm btn-brand",
                        label: "Change Marker Description",
                        disabled: !_ctx.isOnline
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_list, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markerDescriptions, (description, index) => {
                                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                  key: index,
                                  clickable: "",
                                  onClick: ($event: any) => (_ctx.onChangeDescription(description.toUpperCase()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])), [
                                  [_directive_close_popup]
                                ])
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isCompletedRun)
                  ? (_openBlock(), _createElementBlock("br", _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 10,
                      dense: "",
                      "no-caps": "",
                      class: "q-mb-sm btn-brand",
                      disabled: !_ctx.isOnline,
                      onClick: _ctx.onAddNote
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("Add Note ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_q_card, {
          key: 1,
          square: "",
          flat: "",
          bordered: "",
          class: "my-card bg-grey-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createElementVNode("div", { class: "row items-center no-wrap" }, [
                  _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("div", { class: "text-h6 text-weight-bold text-grey-brand" }, " No Marker Selected ")
                  ])
                ], -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addPassageDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addPassageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add Passage", -1)),
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addPassageDialog = false))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.passageTimestamp,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Passage Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.passageTimestamp,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.passageTimestamp,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addPassageDialog = false))
                        }),
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Add",
                          type: "button",
                          "no-caps": "",
                          onClick: _ctx.onAddPassageConfirm
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.assignUidDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.assignUidDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"300px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Assign UID", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    (_ctx.availableUids.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[23] || (_cache[23] = _createTextVNode(" Link marker ", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.marker.name), 1),
                            _cache[24] || (_cache[24] = _createTextVNode(" to AGM Device UID ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_q_select, {
                              modelValue: _ctx.selectedUid,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedUid) = $event)),
                              dense: "",
                              color: "blue-brand",
                              autofocus: "",
                              outlined: "",
                              options: _ctx.availableUids,
                              label: "AGM Device UID"
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, " No AGMs have been assigned to this pig run ")),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": ""
                        }, null, 512), [
                          [_directive_close_popup]
                        ]),
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Link",
                          type: "button",
                          disabled: !_ctx.selectedUid,
                          "no-caps": "",
                          onClick: _ctx.onSaveUidLink
                        }, null, 8, ["disabled", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addNoteDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addNoteDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("Add Note", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.noteLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_q_spinner, {
                        color: "primary",
                        size: "2em"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("form", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.noteText,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.noteText) = $event)),
                          filled: "",
                          type: "textarea",
                          autogrow: "",
                          autofocus: "",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_q_separator),
                      _createVNode(_component_q_card_actions, { align: "center" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_q_btn, {
                            class: "btn-brand",
                            label: "Save",
                            "no-caps": "",
                            onClick: _ctx.onSaveNote
                          }, null, 8, ["onClick"]), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_PipelineSectionMarkerPassagesDialog, {
      ref: "passagesDialog",
      onMarkerChanged: _ctx.onPassagesMarkerChanged
    }, null, 8, ["onMarkerChanged"])
  ]))
}